import { EvaluationFormSchema, SaveNewPercentFormSchema, SaveNewPointFormSchema, SavePercentFormSchema, SavePointFormSchema } from '../evaluationFormManager.validation'
import { rootApi } from '../../../../root.api'

const EFM_ROUTE = 'rest/recording/evalform'

export const efmApiSlice = rootApi.injectEndpoints({
  endpoints: builder => ({
    getAllEvalForms: builder.query<EvaluationFormSchema[], never | void>({
      query: () => `${EFM_ROUTE}?exclude=sections`,
      transformResponse: (response: EvaluationFormSchema[]) => safeParseResponse(response),
      providesTags: ['TableData'],
    }),
    getEvalForm: builder.query<EvaluationFormSchema, number>({
      query: formId => `${EFM_ROUTE}/${formId}`,
      transformResponse: (response: EvaluationFormSchema[]) => EvaluationFormSchema.parse(response[0]),
      providesTags: ['FormData'],
    }),
    updateEvaluationForm: builder.mutation<{ id: number, status: number }, { formId: number, formStatus: number}>({
      query: ({ formId, formStatus }) => ({
        url: `${EFM_ROUTE}/${formId}/status`,
        method: 'PUT',
        body: { 'status': formStatus },
      }),
      invalidatesTags: ['TableData', 'FormData'],
    }),
    deleteEvaluationForm: builder.mutation<{ formId: number, deleted: string }, number>({
      query: formId => ({
        url: `${EFM_ROUTE}/${formId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TableData', 'FormData'],
    }),
    saveEvaluationForm: builder.mutation<EvaluationFormSchema, SavePercentFormSchema | SavePointFormSchema>({
      query: form => ({
        url: `${EFM_ROUTE}/${form.id}`,
        method: 'PUT',
        body: form,
      }),
      invalidatesTags: ['FormData', 'TableData'],
    }),
    saveNewEvaluationForm: builder.mutation<EvaluationFormSchema, SaveNewPercentFormSchema | SaveNewPointFormSchema>({
      query: newForm => ({
        url: `${EFM_ROUTE}/`,
        method: 'POST',
        body: newForm,
      }),
      invalidatesTags: ['TableData'],
    }),
    cloneEvaluationForm: builder.mutation<EvaluationFormSchema, { formId: number, formName: string }>({
      query: ({ formId, formName }) => ({
        url: `${EFM_ROUTE}/${formId}/clone`,
        method: 'POST',
        body: { 'name': formName },
      }),
      invalidatesTags: ['TableData'],
    }),
  }),
  overrideExisting: false,
})

const safeParseResponse = (data: EvaluationFormSchema[]): EvaluationFormSchema[] => {
  const result = []
  for (const form of data) {
    const parsedForm = EvaluationFormSchema.safeParse(form)
    if (parsedForm.success) {
      result.push(parsedForm.data)
    }
    if (!parsedForm.success && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
      console.log('failed to parse form ID', form.id, parsedForm.error.issues)
    }
  }
  return result
}

export const {
  useGetAllEvalFormsQuery,
  useGetEvalFormQuery,
  useCloneEvaluationFormMutation,
  useSaveEvaluationFormMutation,
  useSaveNewEvaluationFormMutation,
  useUpdateEvaluationFormMutation,
  useDeleteEvaluationFormMutation,
} = efmApiSlice
